import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

// GET ALL RENTAL LOCATION
export const getAllRentalLocation = createAsyncThunk('rentalLocation/getAllRentalLocation', async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/location`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

// GET ALL RENTAL LOCATION BY SERVICES
export const getRentalLocationByServices = createAsyncThunk(
  'rentalLocation/getRentalLocationByServices',
  async (payload, thunkAPI) => {
    const { service_id, sub_service_id, facility_id } = payload;

    let newUrl = `/location`;

    if (service_id) {
      newUrl += `?service_id=${service_id}`;
    }

    if (sub_service_id) {
      newUrl += `&sub_service_id=${sub_service_id}`;
    }

    if (facility_id) {
      newUrl += `&facility_id=${facility_id}`;
    }

    try {
      const response = await axiosInstance.get(newUrl);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
    }
  },
);

// CREATE NEW RENTAL LOCATION
export const createRentalLocation = createAsyncThunk(
  'rentalLocation/createRentalLocation',
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`/location`, { ...payload });

      thunkAPI.dispatch(getAllRentalLocation());

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// DELETE RENTAL LOCATION
export const deleteRentalLocation = createAsyncThunk('rentalLocation/deleteRentalLocation', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/location/${id}`);

    thunkAPI.dispatch(getAllRentalLocation());

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// GET RENTAL LOCATION BY ID
export const getRentalLocationById = createAsyncThunk('rentalLocation/getRentalLocationById', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/location/${id}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});

// UPDATE RENTAL LOCATION
export const updateRentalLocation = createAsyncThunk(
  'rentalLocation/updateRentalLocation',
  async ({ id, payload }, thunkAPI) => {
    try {
      const response = await axiosInstance.put(`/location/${id}`, { ...payload });

      thunkAPI.dispatch(getAllRentalLocation());

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getExchangeRate = createAsyncThunk('rentalLocation/getCurrentCurrency', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/convert-currency?from=SGD&to=IDR&amount=1`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data?.data?.message || error.message);
  }
});
